import React, {useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

const SDM_PAY_HOST = process.env.REACT_APP_SDM_PAY_BE
const LiquidationStatus = ['SUBMITTED', 'QUEUED' , 'PENDING_AUTHORIZATION' , 'PENDING_SIGNATURE' , 'BROADCASTING' , 'PENDING_3RD_PARTY_MANUAL_APPROVAL'
, 'PENDING_3RD_PARTY' , 'CONFIRMING' , 'PARTIALLY_COMPLETED' , 'PENDING_AML_SCREENING' , 'COMPLETED' , 'CANCELLED' , 'REJECTED' , 'BLOCKED' , 'FAILED']
function LiquidationStatusUpdateDialog({open, handleClose, liquidationRequest, update, setUpdate}: any) {
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [reference, setReference] = useState('');
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        // console.log(liquidationRequest)
        setUpdatedStatus(liquidationRequest.status)
        setReference(liquidationRequest.proofOfTransaction)
    },[liquidationRequest])
    const handleChange = (event: SelectChangeEvent) => {
        console.log(event.target.value)
        setUpdatedStatus(event.target.value);
        
    };
    const onConfirmStatusChange = async() => {
        setLoading(true)
        try{
            let count = update + 1
            let substatus = '';
            if(updatedStatus == 'COMPLETED'){
                substatus = 'CONFRIMED'
            }
            const result = await axios.post(SDM_PAY_HOST + '/updateLiquidationTransferStatus', {transferId: liquidationRequest.transferId, Status: updatedStatus, SubStatus: substatus})
            const txResult = await axios.post(SDM_PAY_HOST + '/updateTransactionLink', {transferId: liquidationRequest.transferId, transactionLink: reference})
            console.log(result)
            if(result.status === 200){
                setUpdate(count)
                handleClose()
            }
            
        }
        catch(err){
            alert(err)
        }
        setLoading(false)
    }
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Update liquidation request status</DialogTitle>
            <DialogContent>
            {/* <DialogContentText>
                
            </DialogContentText> */}
            <div>
                <Stack direction={'row'} spacing={1}>
                    <span style={{fontWeight: 'bold'}}>Transfer ID: </span>
                    <span>{liquidationRequest.transferId}</span>
                </Stack>
                <Stack direction={'row'} sx={{mt:1}}>
                    <span style={{fontWeight: 'bold'}}>Liquidating Amount: </span>
                    <span>{' ' + liquidationRequest.amount} {liquidationRequest.currency}</span>
                </Stack>
                {/* <Stack direction={'row'} sx={{mt:1}}>
                    <span style={{fontWeight: 'bold'}}>Note: </span>
                    <span>{withdrawalRequest.note}</span>
                </Stack> */}
            </div>
            <div style={{marginTop: 10}}>
                <FormControl variant="filled" sx={{ minWidth: 200 }}>
                    <InputLabel id="demo-simple-select-filled-label">Status</InputLabel>
                    <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={updatedStatus}
                        onChange={handleChange}
                    >
                        {LiquidationStatus.map(status => (<MenuItem key={status} value={status}>{status}</MenuItem>))}
                        {/* <MenuItem value={'canceled'}>Canceled</MenuItem>
                        <MenuItem value={'complete'}>Complete</MenuItem> */}
                    </Select>
                </FormControl>
            </div>
            <div style={{marginTop: 10}}>
                <TextField
                    id="outlined-controlled"
                    label="Reference (etherscan link)"
                    variant="standard"
                    fullWidth
                    value={reference}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setReference(event.target.value);
                    }}
                />
            </div>
            
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                {loading? 
                <LoadingButton
                    loading
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="outlined"
                >
                    Confirm
                </LoadingButton>
                :<Button onClick={() => onConfirmStatusChange()} disabled={updatedStatus === 'COMPLETED' && !reference}>Confirm</Button>}
            </DialogActions>
        </Dialog>
    );
}

export default LiquidationStatusUpdateDialog;